import React from 'react';
import PropTypes from 'prop-types';
import {ParallaxLayer, ExpandingBlurb, Video} from '../../';

export default class StorySection extends React.PureComponent {
    static propTypes = {
        storyData: PropTypes.object,
        active: PropTypes.bool,
        height: PropTypes.number,
        width: PropTypes.number,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        rebuildDirty: PropTypes.bool
    };

    state = {
        play: false
    };

    parallax = null;

    disabled = false;

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            this.disabled = false;
            if (!this.parallax) {
                this.setupParallax();
            } else if (!(this.props.active && nextProps.active)) {
                this.parallax.enable();
                if (process.env.NODE_ENV !== 'production') {
                    console.debug('parallax enable story');
                }
            }
        } else if (!this.disabled && this.parallax) {
            this.parallax.disable();
            if (process.env.NODE_ENV !== 'production') {
                console.debug('parallax disable story');
            }
            this.disabled = true;
        }
        if (!nextProps.active && this.state.play) {
            this.setState({
                play: false
            });
        }

        if (this.props.rebuildDirty !== nextProps.rebuildDirty) {
            this.handleResize();
        }
    }

    handleResize = () => {
        if (!this.parallax) return;

        this.parallax.updateDimensions();
        if (process.env.NODE_ENV !== 'production') {
            console.debug('parallax story updateDimensions');
        }
    };

    componentDidMount() {
        this.setupParallax();
        if (!this.props.active) {
            this.parallax.disable();
        }
    }

    setupParallax = () => {
        if (this.parallax) return;

        if (process.env.NODE_ENV !== 'production') {
            console.debug('setupParallax story');
        }

        const scene = document.getElementById('storyScene');

        const scalarX = this.props.mobile ? 4 : 6;
        const scalarY = this.props.mobile ? 1 : 1;

        this.parallax = new Parallax(scene, {
            limitY: 30,
            limitX: 200,
            scalarX,
            scalarY,
            frictionX: 0.4,
            frictionY: 0.01
        });

        //bc it gets intialized disabled it hits a bug in parallex which doesn't start the device orientation listener without this hack
        if (this.props.mobile || this.props.tablet) {
            this.parallax.orientationStatus = 1;
        }
    };

    imagesLoaded = false;

    playPause = () => {
        this.setState({
            play: !this.state.play
        });
    };

    closeVideo = () => {
        this.setState({
            play: false
        });
    };

    render() {
        const {
            storyData, active, height, width, tablet, mobile
        } = this.props;
        const contentStyle = active ? 'content active' : 'content not-visible';

        const videoId = storyData.videoID || '';

        if (active) this.imagesLoaded = true;

        return (
            <div id="storySection" className="section">
                <div className={`${contentStyle} top`}>
                    <h1>{storyData.title || 'Story'}</h1>
                </div>
                <div role="presentation" onClick={this.closeVideo} className={`overlay ${this.state.play ? 'on' : ''}`} />
                <div id="storyScene" className="parallax-scene">
                    {/* Too many layers cause slowness on mobile devices */}
                    <ParallaxLayer depth={0.1} height={height} width={width} noPointerEvents={true}>
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer6 small' : 'layer6'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.2} height={height} width={width} noPointerEvents={true}>
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer5 small' : 'layer5'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.3} height={height} width={width} noPointerEvents={true} >
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer4 small' : 'layer4'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.4} height={height} width={width} noPointerEvents={true}>
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer3 small' : 'layer3'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.5} height={height} width={width} noPointerEvents={true} >
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer2 small' : 'layer2'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.6} height={height} width={width} noPointerEvents={true}>
                        {active || this.imagesLoaded ?
                            <div className={tablet || mobile ? 'layer1 small' : 'layer1'} /> : ''}
                    </ParallaxLayer>
                </div>
                <div className="gradient" />
                <Video
                    video={videoId}
                    active={active}
                    play={this.state.play}
                    playPauseFunc={this.playPause}
                    poster={false}
                    align="center"
                    backShadow={false}
                    buttonColor="red" />
                <ExpandingBlurb
                    htmlText={storyData.descript || ''}
                    position="bottom"
                    active={active} />
            </div>
        );
    }
}
